import clsx from "clsx";

import { Spin } from "../../feedback/spin/Spin";
import { useStyles } from "./PageSpinner.styles";
import type { PageSpinnerProps } from "./types";

/**
 * This is a custom MyEROAD component. Centered spinner to display when page contents is loading.
 * Use inside Page component or other static positioned container.
 */
const PageSpinner = ({ wrapperClassName, size = "large" }: PageSpinnerProps) => {
  const classes = useStyles();
  return (
    <div className={clsx(classes.root, wrapperClassName)}>
      <Spin size={size} />
    </div>
  );
};

export { PageSpinner };
